export const colorConstants = {
  LOGIN_BUTTON: '#4A4A4A',
  TEXT_BLUE: '#1A9AB0',
  APPROVE_BUTTON: '#00A300',
  BRAND_RED: '#D45C3C',
  INFLUENCER_BLUE: '#0A6CC7',
};
